import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Link from '@base/Link/Link';
import P1 from '@base/P1/P1';
import { Spacings } from '@styles/index';
import H4 from '@base/H4/H4';

const GoalGroupNavContainer = styled.ul`
  grid-column: span 6;
  position: sticky;
  top: 100px;
  height: calc(100vh - 100px);
  padding-inline-start: 0;
  overflow-y: auto;
  padding-bottom: 350px;
  @media (max-width: 70.95em) {
    grid-column: span 7;
  }
  @media (max-width: 47.95em) {
    height: 100%;
    position: relative;
    padding: 0;
    top: ${Spacings.SPACING_0B};
    margin: 0 -16px;
  }
`;

const GoalGroupItem = styled.li`
  padding-bottom: ${Spacings.SPACING_3B};
  list-style-type: none;
  cursor: pointer;
  @media (max-width: 47.95em) {
    box-shadow: inset 0px -1px 0px var(--color-shadow);
    height: 56px;
    align-items: center;
    padding: 0 16px;
    display: ${({ $hide }) => ($hide ? 'none' : 'flex')};
  }
`;

const SelectedGoalGroup = styled(H4)`
  font-size: 16px;
  line-height: 24px;
  color: var(--color-text-primary);
  @media (max-width: 47.95em) {
    font-weight: 400;
  }
`;

const GoalGroupName = styled(P1)`
  line-height: 24px;
  @media (max-width: 47.95em) {
    color: var(--color-text-primary);
    font-size: 16px;
  }
`;

const StyledLink = styled(Link)`
  @media (max-width: 47.95em) {
    display: flex;
    width: 100%;
    justify-content: space-between;
    height: 100%;
    align-items: center;
  }
`;

const RenderGoalGroupItem = ({
  goalGroup,
  id,
  gotoGoalGroupListing,
  currentRefIndex
}) => {
  const handleCardClick = (e) => {
    if (typeof gotoGoalGroupListing === 'function') {
      gotoGoalGroupListing(e, goalGroup, id);
    }
  };
  return (
    <GoalGroupItem $hide={goalGroup.uid === 'my-goals'}>
      <StyledLink
        href={`#${goalGroup.uid}`}
        onClick={handleCardClick}
        role={`goalgroupnav-desktop-${goalGroup.uid}`}
      >
        {currentRefIndex === id ? (
          <SelectedGoalGroup>{goalGroup.name}</SelectedGoalGroup>
        ) : (
          <GoalGroupName color="var(--color-text-secondary)">
            {goalGroup.name}
          </GoalGroupName>
        )}
      </StyledLink>
    </GoalGroupItem>
  );
};
const GoalGroupNav = ({
  goalGroups,
  currentRefIndex,
  setCurrentRefIndex,
  sendOnboardingGoalGroupSelectedEvent,
  onGoalGroupClick
}) => {
  const gotoGoalGroupListing = (e, goalGroup, index) => {
    e.preventDefault();
    setCurrentRefIndex(index);
    onGoalGroupClick(index);
    sendOnboardingGoalGroupSelectedEvent(goalGroup);
    const scrollDistance = document.getElementById(
      `${goalGroup.uid}`
    ).offsetTop;
    window.scrollTo({
      top: scrollDistance,
      behaviour: 'smooth'
    });
  };
  return (
    <GoalGroupNavContainer>
      {goalGroups.map((goalGroup, id) => {
        return goalGroup.children.length > 0 ? (
          <RenderGoalGroupItem
            goalGroup={goalGroup}
            // eslint-disable-next-line react/no-array-index-key
            key={`goal-${id}-${goalGroup.uid}`}
            id={id}
            currentRefIndex={currentRefIndex}
            gotoGoalGroupListing={gotoGoalGroupListing}
          />
        ) : null;
      })}
    </GoalGroupNavContainer>
  );
};

export default GoalGroupNav;

GoalGroupNav.propTypes = {
  goalGroups: PropTypes.arrayOf(PropTypes.any).isRequired,
  currentRefIndex: PropTypes.number.isRequired,
  setCurrentRefIndex: PropTypes.func.isRequired,
  sendOnboardingGoalGroupSelectedEvent: PropTypes.func,
  onGoalGroupClick: PropTypes.func.isRequired
};
GoalGroupNav.defaultProps = {
  sendOnboardingGoalGroupSelectedEvent: () => {}
};
